import { useMemo } from 'react';
import ImageSlider from './ImageSlider';
import BlurredImageSlider from './BlurredImageSlider';
import CoverPageSlider from './CoverPageSlider';

const SliderComponent = ({
    className = '',
    images = [],
    sizes = '100vw',
    withNavigation = false,
    loadPrevNext = false,
    thumbsPosition = "top",
    autoPlay = false,
    nested = false,
    slidesPerView = 1,
    spaceBetween = 0,
    sliderType = '',
    sliderStyle = 'Crop',
    variant = '',
    gallerySize = 'Large' // Large, Medium, or Small
}) => {
    // Map gallerySize to variant
    const effectiveVariant = useMemo(() => {
        if (variant) return variant; // Allow explicit variant override

        switch (gallerySize) {
            case 'Large':
                return withNavigation ? 'gallery-thumbs-below' : '';
            case 'Medium':
                return withNavigation ? 'gallery-thumbs-right' : '';
            case 'Small':
                return ''; // No thumbnails
            default:
                return withNavigation ? 'gallery-thumbs-below' : '';
        }
    }, [gallerySize, variant, withNavigation]);

    // For Small size, disable navigation
    const effectiveWithNavigation = gallerySize === 'Small' ? false : withNavigation;
    if (sliderType === 'coverPage') {
        return (
            <CoverPageSlider
                className={className}
                images={images}
                sizes={sizes}
                withNavigation={effectiveWithNavigation}
                loadPrevNext={loadPrevNext}
                thumbsPosition={thumbsPosition}
                autoPlay={autoPlay}
                nested={nested}
                slidesPerView={slidesPerView}
                spaceBetween={spaceBetween}
                variant={effectiveVariant}
            />
        );
    }

    if (sliderStyle === 'Blur') {
        return (
            <BlurredImageSlider
                className={className}
                images={images}
                sizes={sizes}
                withNavigation={effectiveWithNavigation}
                loadPrevNext={loadPrevNext}
                thumbsPosition={thumbsPosition}
                autoPlay={autoPlay}
                nested={nested}
                slidesPerView={slidesPerView}
                spaceBetween={spaceBetween}
                variant={effectiveVariant}
            />
        );
    }

    return (
        <ImageSlider
            className={className}
            images={images}
            sizes={sizes}
            withNavigation={effectiveWithNavigation}
            loadPrevNext={loadPrevNext}
            thumbsPosition={thumbsPosition}
            autoPlay={autoPlay}
            nested={nested}
            slidesPerView={slidesPerView}
            spaceBetween={spaceBetween}
            variant={effectiveVariant}
        />
    );
};

export default SliderComponent; 